import React from "react";
import { Layout } from "antd";
import { connect } from "react-redux";
import {
  SIDE_NAV_WIDTH,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_DARK,
  NAV_TYPE_SIDE,
} from "constants/ThemeConstant";
import { Scrollbars } from "react-custom-scrollbars";
import MenuContent from "./MenuContent";

const { Sider } = Layout;

export const SideNav = ({
  navCollapsed,
  sideNavTheme,
  currentTheme,
  routeInfo,
  hideGroupTitle,
  localization = true,
}) => {
  const isDarkSideNav =
    currentTheme === "dark" || sideNavTheme === SIDE_NAV_DARK;
  const props = {
    sideNavTheme: isDarkSideNav ? SIDE_NAV_DARK : sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    navCollapsed,
  };
  return (
    <Sider
      className={`side-nav${navCollapsed ? " side-nav--collapsed" : ""}${
        isDarkSideNav ? " side-nav-dark" : ""
      }`}
      width={SIDE_NAV_WIDTH}
      collapsedWidth={SIDE_NAV_COLLAPSED_WIDTH}
      collapsed={navCollapsed}
      trigger={null}
    >
      <Scrollbars autoHide>
        <MenuContent type={NAV_TYPE_SIDE} {...props} />
      </Scrollbars>
    </Sider>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, sideNavTheme, currentTheme } = theme;
  return { navCollapsed, sideNavTheme, currentTheme };
};

export default connect(mapStateToProps)(SideNav);
